// Donate Bee charges a gift as N units of the donation item, so the item's price is the
// smallest gift anyone (or any bot) can pay. This takes over the widget's Give button so the
// quantity follows the item's live price, and gifts start at that price in steps of it.
(() => {
  const HANDLE = 'help-us-with-our-yearly-technology-and-website-costs';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let item;

  const loadItem = () =>
    (item ||= fetch(`${root}products/${HANDLE}.js`)
      .then((r) => r.json())
      .then((p) => ({ id: p.variants[0].id, price: p.variants[0].price })));

  const money = (cents) => `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}`;

  const showNote = (form, text) => {
    let note = form.querySelector('.gb-donation-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'gb-donation-note';
      note.setAttribute('role', 'alert');
      form.appendChild(note);
    }
    note.textContent = text;
  };

  const selectedAmount = (form) => {
    const container = form.closest('.donate-bee-container');
    const data = window.Alpine && container ? window.Alpine.$data(container) : null;
    if (data && data.selectedAmount) return Number(data.selectedAmount);
    const custom = form.querySelector('.donate-bee-form-custom-amount-input');
    if (custom && custom.value) return Number(custom.value);
    const active = form.querySelector('.donate-bee-form-amounts-btn-active');
    return active ? Number(active.textContent.replace(/[^0-9.]/g, '')) : 0;
  };

  // Runs in the capture phase, before Donate Bee's own submit handler on the form.
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest && event.target.closest('.donate-bee-form');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const { id, price } = await loadItem();
      const cents = Math.round(selectedAmount(form) * 100);
      if (!cents || cents < price || cents % price) {
        showNote(form, `Gifts start at ${money(price)} and go up in ${money(price)} steps.`);
        return;
      }

      const button = form.querySelector('.donate-bee-form-submit-btn');
      if (button) button.disabled = true;
      await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: cents / price }] }),
      });
      window.location = `${root}cart`;
    },
    true
  );

  const prepareInputs = async () => {
    const inputs = document.querySelectorAll('.donate-bee-form-custom-amount-input');
    if (!inputs.length) return;
    const { price } = await loadItem();
    inputs.forEach((input) => {
      input.min = price / 100;
      input.step = price / 100;
      input.placeholder = `Custom amount (${money(price)} steps)`;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareInputs);
  else prepareInputs();
})();
